// eslint-disable-next-line
export default {
  icons: {
    logo: require("@src/assets/icons/darkLogo.svg").default,
    rightArrow: require("@src/assets/icons/whiteRightArrow.svg").default,
    orderRightArrow: require("@src/assets/icons/orderArrow.svg").default,
    swap: require("@src/assets/icons/darkSwap.svg").default,
    group: require("@src/assets/icons/whiteGroup.svg").default,
    arrowDown: require("@src/assets/icons/darkArrowDown.svg").default,
    limitOrderArrow: require("@src/assets/icons/darkLimitOrderArrow.svg").default,
    arrowDownWithBorder: require("@src/assets/icons/darkArrowWithBorder.svg").default,
    done: require("@src/assets/icons/darkDone.svg").default,
    add: require("@src/assets/icons/darkAdd.svg").default
  }
};
